import { render } from "./profileLayout.vue?vue&type=template&id=90a3e7e6&ts=true"
import script from "./profileLayout.vue?vue&type=script&lang=ts"
export * from "./profileLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__